import { render, staticRenderFns } from "./PurchasePlanDetail.vue?vue&type=template&id=dc2e798a"
import script from "./PurchasePlanDetail.vue?vue&type=script&lang=js"
export * from "./PurchasePlanDetail.vue?vue&type=script&lang=js"
import style0 from "./PurchasePlanDetail.vue?vue&type=style&index=0&id=dc2e798a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports